import React from 'react';
const AcademicCard = ({ info, handlNaviagtiton, index }) => {
    const randomName = `academic-${index}`;
    const AcademiCdHover = `
    .${randomName}:hover {
       border: 2px solid  ${info?.borderColor};
     }
   `;
    const finalClassName = `program-info  academic-card  ${randomName} `;
    return (
        <>
            <style>
                {AcademiCdHover}
            </style>
            <div className="col-md-6">

                <div
                    onClick={() => handlNaviagtiton(info?.link_text)}
                    className={finalClassName}>
                    <h1>{info?.title} </h1>
                    <p>{ info?.description}</p>
                    {/* <p>{info?.description.length >200? `${info?.description.slice(0,200)} ...`  : info?.description}</p> */}

                </div>
            </div>
        </>
    );
};

export default AcademicCard;